import React, { useEffect, useState } from "react";
import { AutoCenter, Button, Empty } from "antd-mobile";
import { useSelector, useDispatch } from "react-redux";
import { updateWechatState } from "../../redux/slice/wechatSlice";
import BottomNavLayout from "../../components/BottomNavLayout";
import PubHeader from "../../components/PubHeader";
import CreateOrder from "../Order/CreateOrder";
import { useLocation } from "react-router-dom";
import qs from "qs";
import api from "../../api";
import { isWxOrAli } from "../../utils/env";
import "./style.less"

const Scan = () => {
  const wechatState = useSelector((state) => state.wechat)
  const dispatch = useDispatch()
  const location = useLocation()
  const [qrcode, setQrcode] = useState('')
  const [qrcodets, setQrcodets] = useState(Date.now() - 10000)

  // 处理微信直接扫码跳转过来的情况
  const params = qs.parse(location.search.slice(1))
  const passedQrcode = params.qrcode

  // 处理ios异常url
  let url = wechatState.ios ? wechatState.url : window.location.href;

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();

  // 获取全局wx对象
  const wx = window.wx;
  const AlipayJSBridge = window.AlipayJSBridge;

  // 扫码
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#50
  const scanQRCode = () => {
    if (aliOrWx === 'alipay') {
      alipayScanQRCode()
    } else if (aliOrWx === 'wechat') {
      wxScanQRCode()
    }
  }

  const wxScanQRCode = () => {
    wx.scanQRCode({
      needResult: 1,
      scanType: ["qrCode"],
      success: function (res) {
        const qrcode = res.resultStr
        setQrcode(qrcode)
        setQrcodets(Date.now())
      },
      fail: function (res) {
        // alert("error: " + JSON.stringify(res))
      }
    })
  }

  const alipayScanQRCode = () => {
    AlipayJSBridge.call('scan', {
      scanType: ['qrCode'],
      hideAlbum: true,
    }, function (result) {
      if (result.error) {
        return
      }

      const qrcode = result.qrCode;
      setQrcode(qrcode)
      setQrcodets(Date.now())
    });
  }

  const handleInvalidQrcode = () => {
    setQrcode('')
  }

  // 微信初始化配置
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#4
  const wxConfig = (realAuthUrl) => {
    api.wechatJsapiSignature({ url: realAuthUrl }).then((res) => {
      let signature = res.data.data;
      signature.jsApiList = ['scanQRCode', 'chooseWXPay'];
      signature.openTagList = ['wx-open-launch-weapp'];

      wx.config(signature);

      wx.ready(function () {
        // IOS环境特殊处理
        if (wechatState.ios) {
          const newWechatState = {
            url: wechatState.url,
            ios: wechatState.ios,
            loaded: wechatState.loaded,
            iosReady: true
          }
          dispatch(updateWechatState(newWechatState))
        }

        // 立刻扫码
        if (!passedQrcode) {
          scanQRCode()
        }
      });

      wx.error(function (res) {
        // alert("error : " + JSON.stringify(res))
      });
    });
  }

  // 如果是从其他页面跳转过来的，则直接获取qrcode
  const processParams = () => {
    if (passedQrcode) {
      setQrcode(passedQrcode)
      setQrcodets(Date.now())
      return true
    }
    return false
  }

  useEffect(() => {
    if (aliOrWx === 'wechat') {
      // 非ios平台每次都需要config
      if (!wechatState.ios) {
        wxConfig(url)
      } else if (wechatState.iosReady) {
        scanQRCode()
      } else {
        wxConfig(url)
      }
    } else if (aliOrWx === 'alipay' && !passedQrcode) {
      scanQRCode()
    }

    // passed qrcode
    if (passedQrcode) {
      processParams()
    }
  }, [])

  return (
    <BottomNavLayout>
      <PubHeader title="充电" backToHome={true} />
      <div className="scan-wrapper">
        {
          qrcode ?
            <CreateOrder aliOrWx={aliOrWx} qrcode={qrcode} qrcodets={qrcodets} handleInvalidQrcode={handleInvalidQrcode} />
            :
            <div>
              <Empty
                style={{ padding: '128px 0' }}
                imageStyle={{ width: 128 }}
                description='哎呀，还没有设备被扫码'
              />
              <AutoCenter>
                <Button color='success' onClick={scanQRCode}>点我扫码充电</Button>
              </AutoCenter>
            </div>
        }
      </div>
    </BottomNavLayout>
  )
}

export default Scan;